// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"EmptyCart-module__pageContainer___K9Nnd","emptyCart__icon":"EmptyCart-module__emptyCart__icon___3DDbi","emptyCart__text":"EmptyCart-module__emptyCart__text___32MtC","emptyCart__link":"EmptyCart-module__emptyCart__link___1zf8V"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/CheckoutCart/EmptyCart/EmptyCart.module.css
// module id = 624
// module chunks = 0